






// https://webpack.js.org/guides/dependency-management/#context-module-api
import { Component, Vue, Prop } from "vue-property-decorator";

const requireAll = (requireContext: any) => requireContext.keys().map(requireContext)
const req = require.context('../assets/svg', false, /\.svg$/)
requireAll(req)

@Component
export default class SvgIcon extends Vue {
  @Prop() iconName!: string;
  @Prop() width!: string;
  @Prop() height!: string;

  get name(): string {
    const icon = this.iconName;
    return icon ? `sprite.svg#icon-${icon}` : '';
    // return icon ? `#icon-${icon}` : '';
  }
}
